import React, { useState, useEffect, useCallback, useRef } from "react";
import env from "../../config/env.js";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, TableSortLabel,
  Tooltip, Select, MenuItem, FormControl, InputLabel, FormHelperText,
  Snackbar, Alert, TablePagination, useTheme, CircularProgress, Chip,
  Tabs, Tab, InputAdornment, FormControlLabel, Checkbox
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Close as CloseIcon,
  Build as BuildIcon
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import * as MuiIcons from "@mui/icons-material";
import api from "../../services/api";
import { 
  formatarMoeda,
  formatarMoedaInput,
  converterMoedaParaNumero,
  formatarData,
  converterStringParaDate,
  converterDateParaString
} from "../../utils/formatadores";
import { verificarAcessoUsuario } from "../../utils/authStandards";
import AcessoRestrito from '../../components/AcessoRestrito';

// Recharts Components (removidos - não utilizados na versão simplificada)

// Constantes para evitar hardcode
const CONSTANTS = {
  DRAWER_WIDTH: 280,
  API_TIMEOUT: 30000,
  DEFAULT_LIMIT: 20,
  UPDATE_INTERVAL: 60000,
  NOTIFICATION_DURATION: env.NOTIFICATION_DURATION || 6000,
  HTTP_STATUS: {
    MIN_SUCCESS: 200,
    MAX_SUCCESS: 500
  },
  DIMENSIONS: {
    MOBILE_BREAKPOINT: '600px',
    TABLE_BREAKPOINT: '650px',
    DESKTOP_BREAKPOINT: '800px',
    FORM_HEIGHT: '550px',
    HEADER_HEIGHT: '140px',
    FOOTER_HEIGHT: '120px'
  }
};

const normalizarId = (valor) => String(valor ?? '');

// Categorias agora são carregadas dinamicamente da API

export default function Servicos() {
  const [servicos, setServicos] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [servicoParaExcluir, setServicoParaExcluir] = useState(null);
  const [moduleInfo, setModuleInfo] = useState(null);

  const location = useLocation();

  // Carregar informações do módulo ao inicializar
  useEffect(() => {
    const carregarInfoModulo = async () => {
      try {
        // Tenta obter informações do módulo do localStorage (carregadas pelo MainLayout)
        const rotasModulos = JSON.parse(localStorage.getItem('rotasModulos') || '[]');
        const pathname = location.pathname;
        const moduleName = pathname.split('/')[1]; // Ex: "/servicos" -> "servicos"
        
        // Procura o módulo atual nas rotas carregadas
        const moduloAtual = rotasModulos.find(rota => rota.path === `/${moduleName}`);
        
        if (moduloAtual) {
          setModuleInfo(moduloAtual);
        } else {
          // Fallback para informações padrão do módulo
          setModuleInfo({
            nome: 'Serviços',
            icone: 'servicos',
            path: '/servicos'
          });
        }
      } catch (error) {
        console.warn('Erro ao carregar informações do módulo:', error);
        // Fallback para informações padrão
        setModuleInfo({
          nome: 'Serviços',
          icone: 'servicos',
          path: '/servicos'
        });
      }
    };

    carregarInfoModulo();
  }, [location.pathname]);

  const [formData, setFormData] = useState({
    nome: "",
    descricao: "",
    categoria: "",
    tipo_disponibilidade: "unico",
    tipo_cobranca: "valor_total",
    duracao_minutos: "",
    recorrencia: {
      frequencia: "semanal",
      diasDaSemana: [],
      dataFim: ""
    },
    precificacao: {
      valorCliente: "",
      valorColaborador: "",
      taxaAdministrativa: "",
      custosAdicionaisColaborador: []
    },
    validade: {
      dataInicio: "",
      dataFim: ""
    },
    local_execucao: {
      tipo: "online",
      id: null,
      local: "",
      horario_inicio: ""
    },
    garantia_dias: "",
    colaboradores: []
  });
  const [servicoSelecionado, setServicoSelecionado] = useState(null);
  const [orderBy, setOrderBy] = useState("nome");
  const [order, setOrder] = useState("asc");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [, setFormErrors] = useState({
    nome: false,
    categoria: false,
    tipo_disponibilidade: false,
    tipo_cobranca: false,
    duracao_minutos: false
  });
  const [openView, setOpenView] = useState(false);
  const [servicoVisualizar, setServicoVisualizar] = useState(null);
  const [colaboradoresAssociados, setColaboradoresAssociados] = useState([]);
  const [loadingColaboradoresAssociados, setLoadingColaboradoresAssociados] = useState(false);
  const [filtros, setFiltros] = useState({
    nome: '',
    categoria: '',
    tipo_disponibilidade: '',
    tipo_cobranca: ''
  });
  const [activeTab, setActiveTab] = useState(0);
  const [openForm, setOpenForm] = useState(false);
  const [dataHoraAtual, setDataHoraAtual] = useState(new Date());
  const [locais, setLocais] = useState([]);
  const [loadingLocais, setLoadingLocais] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [camposPreenchidos, setCamposPreenchidos] = useState(new Set());
  const [proximoCampo, setProximoCampo] = useState('nome');
  
  const token = localStorage.getItem("token");
  const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
  const theme = useTheme();

  const obterCategoriaDoServico = (categoriaServico) => {
    if (categoriaServico && typeof categoriaServico === 'object') {
      return categoriaServico;
    }

    return categorias.find((categoria) =>
      String(categoria.categoriaId) === String(categoriaServico) ||
      categoria.st_nomeCategoria === categoriaServico
    );
  };

  const obterNomeCategoria = (categoriaServico) => {
    const categoria = obterCategoriaDoServico(categoriaServico);

    if (categoria) {
      return categoria.st_nomeCategoria || categoria.st_descricao || 'Categoria sem descrição';
    }

    // Mantém compatibilidade com registros antigos que armazenavam o nome.
    if (typeof categoriaServico === 'string' && categoriaServico && !/^\d+$/.test(categoriaServico)) {
      return categoriaServico;
    }

    return 'Categoria não encontrada';
  };

  // Função para obter ícone dinamicamente
  const getMuiIconByName = (nomeIcone) => {
    if (!nomeIcone) return <BuildIcon sx={{ color: "#FFC107" }} />;

    // Mapeamento especial para ícones que não seguem o padrão
    const mapeamentoEspecial = {
      'restore': 'Restore',
      'dashboard': 'Dashboard',
      'users': 'People',
      'user': 'Person',
      'company': 'Business',
      'service': 'Build',
      'schedule': 'Schedule',
      'finance': 'AttachMoney',
      'report': 'Assessment',
      'settings': 'Settings',
      'clientes': 'Person',
      'colaboradores': 'People',
      'usuarios': 'Person',
      'servicos': 'Build'
    };

    // Verifica se há um mapeamento especial
    if (mapeamentoEspecial[nomeIcone]) {
      const nomeMapeado = mapeamentoEspecial[nomeIcone];
      if (Object.prototype.hasOwnProperty.call(MuiIcons, nomeMapeado)) {
        const IconComponent = MuiIcons[nomeMapeado];
        return <IconComponent sx={{ color: theme.palette.warning.main }} />;
      }
    }

    // Tenta carregar diretamente
    if (Object.prototype.hasOwnProperty.call(MuiIcons, nomeIcone)) {
      const IconComponent = MuiIcons[nomeIcone];
      return <IconComponent sx={{ color: theme.palette.warning.main }} />;
    }

    // Fallback para ícone padrão
    return <BuildIcon sx={{ color: theme.palette.warning.main }} />;
  };

  // Obter ícone do módulo atual baseado nas informações carregadas
  const getModuleIcon = () => {
    // Se temos informações do módulo, usa o ícone específico
    if (moduleInfo && moduleInfo.icone) {
      return getMuiIconByName(moduleInfo.icone);
    }
    
    // Fallback baseado na rota - usando o mesmo ícone do MenuLateral
    const pathname = location.pathname;
    const moduleName = pathname.split('/')[1]; // Ex: "/servicos" -> "servicos"
    
    // Mapeamento dos ícones conforme MenuLateral.jsx
    const iconMap = {
      'servicos': 'Build' // Mesmo ícone usado no MenuLateral.jsx
    };
    
    return getMuiIconByName(iconMap[moduleName] || 'Build');
  };

  const mounted = useRef(true);

  // Função para criar logs de autenticação (removida - agora é feita no backend)

  const carregarServicos = useCallback(async () => {
    if (!token || !codHashEmpresa) {
      setError("Sessão expirada ou inválida. Por favor, faça login novamente.");
      return;
    }

    if (!mounted.current) return;

    try {
      setLoading(true);
      setError(null);
      
      const params = {
        todos: true,
        ...(filtros.nome && { nome: filtros.nome }),
        ...(filtros.categoria && { categoria: filtros.categoria }),
        ...(filtros.tipo_disponibilidade && { tipo_disponibilidade: filtros.tipo_disponibilidade }),
        ...(filtros.tipo_cobranca && { tipo_cobranca: filtros.tipo_cobranca })
      };

      const res = await api.get('/servicos', { 
        params,
        timeout: CONSTANTS.API_TIMEOUT,
        validateStatus: function (status) {
          return status >= CONSTANTS.HTTP_STATUS.MIN_SUCCESS && status < CONSTANTS.HTTP_STATUS.MAX_SUCCESS;
        }
      });
      
      if (!mounted.current) {
        return;
      }
      
      if (res.data && Array.isArray(res.data.dados)) {
        setServicos(res.data.dados);
      } else {
        setServicos([]);
      }
      } catch (error) {
      if (!mounted.current) {
        return;
      }

      console.error("Erro ao carregar serviços:", error.message);
      
      let mensagemErro = "Erro ao carregar serviços";
      
      if (error.code === 'ECONNABORTED') {
        mensagemErro = "Tempo limite excedido ao carregar serviços. Tente novamente.";
      } else if (error.response?.status === 401) {
        mensagemErro = "Sessão expirada. Por favor, faça login novamente.";
      }
      
      setError(mensagemErro);
      } finally {
        if (mounted.current) {
        setLoading(false);
      }
    }
  }, [token, codHashEmpresa, filtros.nome, filtros.categoria, filtros.tipo_disponibilidade, filtros.tipo_cobranca]);

  // Função para obter um serviço específico
  const obterServico = useCallback(async (servicoId) => {
    if (!token || !codHashEmpresa || !servicoId) return null;

    try {
      const res = await api.get(`/servicos/${servicoId}`, {
        timeout: CONSTANTS.API_TIMEOUT,
        validateStatus: function (status) {
          return status >= 200 && status < 500;
        }
      });
      
      if (res.status === 404) {
        return null;
      }
      
      return res.data;
    } catch (error) {
      console.error("Erro ao obter serviço:", error);
      
      // Tratamento específico para diferentes tipos de erro
      if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        setError("Tempo limite excedido ao buscar serviço. Tente novamente.");
      } else if (error.response?.status === 504) {
        setError("Servidor demorou muito para responder. Tente novamente.");
      } else if (error.response?.status === 404) {
        setError("Serviço não encontrado.");
      } else {
        setError(error.response?.data?.message || "Erro ao obter serviço");
      }
      
      return null;
    }
  }, [token, codHashEmpresa]);

  const carregarCategorias = useCallback(async () => {
    if (!mounted.current || !token) return;

    try {
      setLoadingCategorias(true);
      
      const res = await api.get('/categoria/empresa/' + codHashEmpresa);

      if (!mounted.current) return;
      
      setCategorias(res.data || []);
    } catch (error) {
      if (!mounted.current) return;
      console.error("Erro ao carregar categorias:", error);
      setError("Erro ao carregar categorias");
    } finally {
      if (mounted.current) {
        setLoadingCategorias(false);
      }
    }
  }, [token, codHashEmpresa]);

  const carregarColaboradores = useCallback(async () => {
    if (!mounted.current || !token || !codHashEmpresa) return;

    try {
      const res = await api.get('/colaboradores');

      if (!mounted.current) return;
      
      let colaboradoresFiltrados = res.data || [];
      if (Array.isArray(colaboradoresFiltrados)) {
        colaboradoresFiltrados = colaboradoresFiltrados.filter(
          colaborador => colaborador.status === 'Ativo'
        );
      }
      
      setColaboradores(colaboradoresFiltrados);
    } catch (error) {
      if (!mounted.current) return;
      console.error("Erro ao carregar colaboradores:", error);
      setError("Erro ao carregar colaboradores");
    }
  }, [token, codHashEmpresa]);

  const carregarLocais = useCallback(async () => {
    if (!token || !codHashEmpresa) {
      setError("Sessão expirada ou inválida. Por favor, faça login novamente.");
      return;
    }

    try {
      setLoadingLocais(true);
      
      const res = await api.get(`/local`, {
        params: { st_codHashEmpresa: codHashEmpresa }
      });
      
      setLocais(res.data || []);
    } catch (error) {
      console.error("Erro ao carregar locais:", error);
      setError("Erro ao carregar locais");
      setLocais([]);
    } finally {
      setLoadingLocais(false);
    }
  }, [token, codHashEmpresa]);

  // Função para carregar colaboradores associados a um serviço
  const carregarColaboradoresAssociados = useCallback(async (servicoId) => {
    if (!token || !codHashEmpresa || !servicoId) return;
    
    try {
      setLoadingColaboradoresAssociados(true);
      const response = await api.get(`/servico-colaboradores/${servicoId}`);
      setColaboradoresAssociados(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar colaboradores associados:', error);
      setColaboradoresAssociados([]);
    } finally {
      setLoadingColaboradoresAssociados(false);
    }
  }, [token, codHashEmpresa]);

  // Carregar dados iniciais
  useEffect(() => {
    mounted.current = true;
    carregarServicos();
    carregarCategorias();
    carregarColaboradores();
    carregarLocais();

    return () => {
      mounted.current = false;
    };
  }, [carregarServicos, carregarCategorias, carregarColaboradores, carregarLocais]);

  // Atualizar data/hora atual
  useEffect(() => {
    const interval = setInterval(() => {
      setDataHoraAtual(new Date());
    }, CONSTANTS.UPDATE_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  // Funções de ordenação e paginação
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Funções de filtro
  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({ ...prev, [name]: value }));
    setPage(0);
  };

  // Ordem sequencial dos campos obrigatórios
  const ordemCampos = ['nome', 'categoria', 'duracao_minutos', 'tipo_cobranca'];
  
  // Função para formatar data durante a digitação (DD/MM/AAAA)
  const handleDataChange = (campo, valor) => {
    if (!valor) {
      return '';
    }
    
    // Remove caracteres não numéricos
    const numeros = valor.replace(/\D/g, '');
    
    // Se tiver mais de 8 dígitos, limita a 8
    if (numeros.length > 8) {
      return valor.slice(0, valor.length - 1);
    }
    
    // Formata como DD/MM/AAAA
    let dataFormatada = '';
    if (numeros.length >= 1) dataFormatada += numeros.slice(0, 1);
    if (numeros.length >= 2) dataFormatada += numeros.slice(1, 2) + '/';
    if (numeros.length >= 3) dataFormatada += numeros.slice(2, 3);
    if (numeros.length >= 4) dataFormatada += numeros.slice(3, 4) + '/';
    if (numeros.length >= 5) dataFormatada += numeros.slice(4, 8);
    
    return dataFormatada;
  };
  
  // Funções de formulário
  const resetForm = () => {
    setFormData({
      nome: "",
      descricao: "",
      categoria: "",
      tipo_disponibilidade: "unico",
      tipo_cobranca: "valor_total",
      duracao_minutos: "",
      recorrencia: {
        frequencia: "semanal",
        diasDaSemana: [],
        dataFim: ""
      },
      precificacao: {
        valorCliente: "",
        valorColaborador: "",
        taxaAdministrativa: "",
        custosAdicionaisColaborador: []
      },
      validade: {
        dataInicio: "",
        dataFim: ""
      },
      local_execucao: {
        tipo: "online",
        id: null,
        local: "",
        horario_inicio: ""
      },
      garantia_dias: "",
      colaboradores: []
    });
    setFormErrors({
      nome: false,
      categoria: false,
      tipo_disponibilidade: false,
      tipo_cobranca: false,
      duracao_minutos: false
    });
    setCamposPreenchidos(new Set());
    setProximoCampo('nome');
  };

  // Função para validar campo e atualizar progresso
  const validarCampo = (nomeCampo, valor) => {
    const novoSet = new Set(camposPreenchidos);
    
    // Validações específicas por campo
    let campoValido = false;
    switch (nomeCampo) {
      case 'nome':
        campoValido = valor && typeof valor === 'string' && valor.trim().length > 0;
        break;
      case 'categoria':
        // Categoria pode ser número (ID) ou string
        campoValido = valor !== null && valor !== undefined && valor !== '';
        break;
      case 'duracao_minutos':
        campoValido = valor && !isNaN(valor) && parseInt(valor) > 0;
        break;
      case 'tipo_cobranca':
        // Tipo de cobrança pode ser string ou número
        campoValido = valor !== null && valor !== undefined && valor !== '';
        break;
      default:
        // Para outros campos, verificar se é string antes de usar trim
        if (typeof valor === 'string') {
          campoValido = valor.trim().length > 0;
        } else {
          campoValido = valor !== null && valor !== undefined && valor !== '';
        }
    }
    
    if (campoValido) {
      novoSet.add(nomeCampo);
      setCamposPreenchidos(novoSet);
      
      // Determinar próximo campo
      const indiceAtual = ordemCampos.indexOf(nomeCampo);
      if (indiceAtual >= 0 && indiceAtual < ordemCampos.length - 1) {
        setProximoCampo(ordemCampos[indiceAtual + 1]);
      }
    } else {
      novoSet.delete(nomeCampo);
      setCamposPreenchidos(novoSet);
    }
  };

  // Função auxiliar para normalizar tipo de local_execucao
  const normalizarTipoLocalExecucao = (tipo) => {
    if (!tipo) return 'online';
    const tipoLower = String(tipo).toLowerCase().trim();
    const tiposValidos = ['presencial', 'online', 'hibrido'];
    
    if (tiposValidos.includes(tipoLower)) {
      return tipoLower;
    }
    
    // Se o tipo não for válido (ex: "sala", "consultorio", etc), usar 'presencial' como padrão
    return 'presencial';
  };

  // Função auxiliar para converter data DD/MM/YYYY para YYYY-MM-DD (usando formatadores.js)
  const converterDataParaISO = (dataPTBR) => {
    if (!dataPTBR) return null;
    const dateObj = converterStringParaDate(dataPTBR);
    if (!dateObj) return null;
    return converterDateParaString(dateObj);
  };

  // Função auxiliar para converter data para exibição PT-BR (usando formatadores.js)
  const converterDataParaBR = (dataISO) => {
    if (!dataISO) return '';
    return formatarData(dataISO);
  };

  // Função auxiliar para converter data para formato do input HTML5 YYYY-MM-DD (usando formatadores.js)
  const converterDataParaInputDate = (dataISO) => {
    if (!dataISO) return '';
    // Se já estiver no formato YYYY-MM-DD, retornar como está
    if (typeof dataISO === 'string' && dataISO.match(/^\d{4}-\d{2}-\d{2}/)) {
      return dataISO.split('T')[0]; // Remove hora se houver
    }
    // Converter usando formatadores.js
    const dateObj = converterStringParaDate(dataISO);
    if (!dateObj) return '';
    return converterDateParaString(dateObj);
  };

  // Array de dias da semana (reutilizável)
  const diasDaSemana = [
    { value: 'segunda', label: 'Segunda' },
    { value: 'terca', label: 'Terça' },
    { value: 'quarta', label: 'Quarta' },
    { value: 'quinta', label: 'Quinta' },
    { value: 'sexta', label: 'Sexta' },
    { value: 'sabado', label: 'Sábado' },
    { value: 'domingo', label: 'Domingo' }
  ];

  // Função auxiliar para validar campos obrigatórios
  const validarCamposObrigatorios = () => {
    const erros = [];
    
    // Validar nome
    const nome = typeof formData.nome === 'string' ? formData.nome.trim() : (formData.nome ? String(formData.nome).trim() : '');
    if (!nome || nome === '') {
      erros.push('Nome do serviço é obrigatório');
    } else if (nome.length < 3) {
      erros.push('Nome do serviço deve ter pelo menos 3 caracteres');
    }
    
    // Validar categoria (pode ser string ou número - ID da categoria)
    if (formData.categoria === null || formData.categoria === undefined || formData.categoria === '' || 
        (typeof formData.categoria === 'string' && formData.categoria.trim() === '')) {
      erros.push('Categoria é obrigatória');
    }
    
    // Validar duração
    const duracao = formData.duracao_minutos;
    if (duracao === null || duracao === undefined || duracao === '' || (typeof duracao === 'string' && duracao.trim() === '')) {
      erros.push('Duração é obrigatória');
    } else {
      const duracaoNum = parseInt(String(duracao), 10);
      if (isNaN(duracaoNum) || duracaoNum <= 0) {
        erros.push('Duração deve ser um número maior que zero');
      }
    }
    
    // Validar tipo de cobrança
    if (!formData.tipo_cobranca || formData.tipo_cobranca === '') {
      erros.push('Tipo de cobrança é obrigatório');
    }
    
    // Validar tipo de disponibilidade
    if (!formData.tipo_disponibilidade || formData.tipo_disponibilidade === '') {
      erros.push('Tipo de disponibilidade é obrigatório');
    }
    
    // Validar datas se fornecidas (formato DD/MM/AAAA ou YYYY-MM-DD)
    const validarData = (data, nomeCampo) => {
      if (!data || data === '' || data === null) return true; // Data opcional
      const dataStr = String(data).trim();
      
      // Validar formato YYYY-MM-DD
      if (dataStr.match(/^\d{4}-\d{2}-\d{2}/)) {
        const dateObj = converterStringParaDate(dataStr);
        if (!dateObj || isNaN(dateObj.getTime())) {
          erros.push(`${nomeCampo} deve ser uma data válida`);
          return false;
        }
        return true;
      }
      
      // Validar formato DD/MM/AAAA
      if (dataStr.includes('/')) {
        const dateObj = converterStringParaDate(dataStr);
        if (!dateObj || isNaN(dateObj.getTime())) {
          erros.push(`${nomeCampo} deve estar no formato DD/MM/AAAA`);
          return false;
        }
        return true;
      }
      
      erros.push(`${nomeCampo} deve estar no formato DD/MM/AAAA ou YYYY-MM-DD`);
      return false;
    };
    
    // Validar datas de validade se fornecidas
    if (formData.validade?.dataInicio) {
      validarData(formData.validade.dataInicio, 'Data de início da validade');
    }
    if (formData.validade?.dataFim) {
      validarData(formData.validade.dataFim, 'Data de fim da validade');
    }
    
    // Validar data de fim da recorrência se fornecida
    if (formData.recorrencia?.dataFim) {
      validarData(formData.recorrencia.dataFim, 'Data de fim da recorrência');
    }
    
    // Se houver erros, exibir mensagem e retornar false
    if (erros.length > 0) {
      setError(erros.join('. '));
      return false;
    }
    
    return true;
  };

  // Função auxiliar para formatar dados do formulário para envio
  const formatarDadosFormulario = () => {
    // Formatar nome e descrição
    const nome = typeof formData.nome === 'string' ? formData.nome.trim() : String(formData.nome || '').trim();
    const descricao = typeof formData.descricao === 'string' ? formData.descricao.trim() : (formData.descricao ? String(formData.descricao).trim() : null);
    
    // ✅ CORREÇÃO: Garantir que o ID da categoria seja enviado, não o nome.
    // O backend espera o ID da categoria como uma string.
    let categoriaIdParaEnvio = null;
    if (formData.categoria) {
      // Verifica se o valor já é um ID numérico ou uma string numérica
      if (!isNaN(Number(formData.categoria))) {
        categoriaIdParaEnvio = String(formData.categoria);
      } else {
        // Se for uma string (ex: "Saúde"), busca o ID correspondente.
        const categoriaEncontrada = categorias.find(
          (cat) => cat.st_nomeCategoria === formData.categoria
        );
        if (categoriaEncontrada) categoriaIdParaEnvio = String(categoriaEncontrada.categoriaId);
      }
    }
    
    // Validar e converter duracao_minutos (já validado antes, sempre deve ter valor válido)
    // Como a validação já garantiu que duracao_minutos existe e é > 0, sempre deve converter corretamente
    let duracaoMinutos = null;
    if (formData.duracao_minutos !== null && formData.duracao_minutos !== undefined && formData.duracao_minutos !== '') {
      const parsed = parseInt(String(formData.duracao_minutos), 10);
      if (!isNaN(parsed) && parsed > 0) {
        duracaoMinutos = parsed;
      } else {
        // Fallback: tentar Number() se parseInt falhar
        const valorNumerico = Number(formData.duracao_minutos);
        if (!isNaN(valorNumerico) && valorNumerico > 0) {
          duracaoMinutos = Math.floor(valorNumerico);
        }
      }
    }
    
    // Se ainda for null após todas as tentativas, usar valor padrão mínimo (não deveria acontecer após validação)
    if (duracaoMinutos === null) {
      console.warn('Aviso: duracao_minutos é null após validação, usando valor padrão 1');
      duracaoMinutos = 1; // Valor mínimo válido
    }
    
    // Validar e converter garantia_dias
    let garantiaDias = null;
    if (formData.garantia_dias !== null && formData.garantia_dias !== undefined && formData.garantia_dias !== '') {
      const parsed = parseInt(String(formData.garantia_dias), 10);
      if (!isNaN(parsed) && parsed >= 0) {
        garantiaDias = parsed;
      }
    }

    // Formatar validade - converter DD/MM/AAAA para YYYY-MM-DD se necessário
    const converterDataParaISO = (data) => {
      if (!data || data === '' || data === null) return null;
      const dataStr = String(data).trim();
      // Se já estiver em YYYY-MM-DD, retornar como está
      if (dataStr.match(/^\d{4}-\d{2}-\d{2}/)) {
        return dataStr.split('T')[0]; // Remove hora se houver
      }
      // Se estiver em DD/MM/AAAA, converter para YYYY-MM-DD
      if (dataStr.includes('/')) {
        const dateObj = converterStringParaDate(dataStr);
        if (!dateObj) return null;
        return converterDateParaString(dateObj);
      }
      return null;
    };

    const validadeDataInicio = converterDataParaISO(formData.validade?.dataInicio);
    const validadeDataFim = converterDataParaISO(formData.validade?.dataFim);
    const validade = (validadeDataInicio || validadeDataFim) ? {
      dataInicio: validadeDataInicio,
      dataFim: validadeDataFim
    } : null;

    // Formatar recorrência - converter DD/MM/AAAA para YYYY-MM-DD se necessário
    const recorrenciaDataFim = converterDataParaISO(formData.recorrencia?.dataFim);
    
    // Converter dias da semana de strings para números se necessário
    // Mapeamento: segunda=1, terca=2, quarta=3, quinta=4, sexta=5, sabado=6, domingo=0
    const mapearDiaParaNumero = (dia) => {
      const mapa = {
        'segunda': 1,
        'terca': 2,
        'quarta': 3,
        'quinta': 4,
        'sexta': 5,
        'sabado': 6,
        'domingo': 0
      };
      return mapa[dia.toLowerCase()] !== undefined ? mapa[dia.toLowerCase()] : dia;
    };
    
    const diasDaSemana = Array.isArray(formData.recorrencia?.diasDaSemana) && formData.recorrencia.diasDaSemana.length > 0 
      ? formData.recorrencia.diasDaSemana.map(dia => {
          // Se for string, converter para número; se já for número, manter
          return typeof dia === 'string' ? mapearDiaParaNumero(dia) : dia;
        })
      : [];
    
    const recorrencia = (formData.tipo_disponibilidade === 'recorrente' && (recorrenciaDataFim || diasDaSemana.length > 0)) ? {
      frequencia: formData.recorrencia?.frequencia || 'semanal',
      diasDaSemana: diasDaSemana,
      dataFim: recorrenciaDataFim
    } : null;

    // Formatar local_execucao - enviar null se online ou se não tiver dados
    const tipoLocal = normalizarTipoLocalExecucao(formData.local_execucao?.tipo);
    let localExecucao = null;
    if (tipoLocal === 'online') {
      localExecucao = { tipo: 'online' };
    } else if (tipoLocal !== 'online' && formData.local_execucao?.id) {
      const localId = parseInt(formData.local_execucao.id.toString(), 10);
      if (!isNaN(localId) && localId > 0) {
        localExecucao = {
          tipo: tipoLocal,
          id: localId,
          local: formData.local_execucao.local || null,
          horario_inicio: formData.local_execucao.horario_inicio || null
        };
      }
    }

    // Garantir que duracao_minutos seja sempre um número válido
    const duracaoFinal = typeof duracaoMinutos === 'number' && !isNaN(duracaoMinutos) && duracaoMinutos > 0 
      ? duracaoMinutos 
      : null;

    return {
      nome: nome && nome.trim() !== '' ? nome.trim() : (nome || ''),
      descricao: descricao && descricao !== null && descricao.trim() !== '' ? descricao.trim() : null,
      categoria: categoriaIdParaEnvio,
      tipo_disponibilidade: formData.tipo_disponibilidade || 'unico',
      tipo_cobranca: formData.tipo_cobranca || 'valor_total',
      duracao_minutos: duracaoFinal,
      garantia_dias: (garantiaDias !== null && garantiaDias !== undefined) ? garantiaDias : null,
      precificacao: {
        valorCliente: converterMoedaParaNumero(formData.precificacao?.valorCliente || '0'),
        valorColaborador: converterMoedaParaNumero(formData.precificacao?.valorColaborador || '0'),
        taxaAdministrativa: converterMoedaParaNumero(formData.precificacao?.taxaAdministrativa || '0')
      },
      validade: validade,
      recorrencia: recorrencia,
      local_execucao: localExecucao,
      colaboradores: Array.isArray(formData.colaboradores) ? formData.colaboradores : [],
      st_codHashEmpresa: codHashEmpresa || ''
    };
  };

  // Estilos comuns para dialogs
  const dialogCommonStyles = {
    title: {
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
      borderBottom: 1,
      borderColor: 'divider',
      padding: 2,
      position: 'sticky',
      top: 0,
      zIndex: 1,
      fontSize: '1.25rem',
      fontWeight: 500
    },
    content: {
      height: 'calc(100% - 140px)',
      overflow: 'auto',
      padding: 2,
      '&.MuiDialogContent-root': {
        paddingTop: 2
      },
      position: 'relative',
      top: 0,
      marginBottom: '60px',
      '& .MuiInputLabel-root': {
        fontSize: '0.875rem'
      },
      '& .MuiInputBase-input': {
        fontSize: '0.875rem'
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '0.875rem'
      }
    },
    actions: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
      borderTop: 1,
      borderColor: 'divider',
      zIndex: 1,
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    paperProps: {
      sx: {
        width: { xs: '95vw', sm: '90vw', md: '900px' },
        height: { xs: '95vh', sm: '90vh', md: '550px' },
        maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
        maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
        position: 'relative',
        margin: { xs: 'auto', sm: 'auto', md: 'auto' }
      }
    }
  };

  // Funções de ação
  const handleAbrirCreate = () => {
    resetForm();
    setServicoSelecionado(null); // Garantir que não há serviço selecionado
    setActiveTab(0);
    setOpenForm(true);
  };

  const handleAbrirEdit = async (servico) => {
    try {
      setLoading(true);

      // Tentar buscar o serviço completo do backend
      let servicoCompleto = await obterServico(servico.id);
      
      // Se não conseguir do backend, usar os dados da lista como fallback
      if (!servicoCompleto) {
        servicoCompleto = servico;
      }

      setServicoSelecionado(servicoCompleto);
      
      // Converter colaboradores para array de IDs se vierem como objetos
      let colaboradoresIds = [];
      if (servicoCompleto.colaboradores && Array.isArray(servicoCompleto.colaboradores)) {
        colaboradoresIds = servicoCompleto.colaboradores.map(col => {
          // Se for objeto, pegar o ID; se já for ID, usar diretamente
          return typeof col === 'object' ? col.id : col;
        });
      }

      // Resolver ID da categoria a partir do nome ou ID existente
      let categoriaId = "";
      if (servicoCompleto.categoria) {
        const found = categorias.find(
          (cat) =>
            String(cat.categoriaId) === String(servicoCompleto.categoria) ||
            cat.st_nomeCategoria === servicoCompleto.categoria
        );
        categoriaId = found ? found.categoriaId : "";
      }

      setFormData({
        nome: servicoCompleto.nome || "",
        categoria: categoriaId,
        tipo_disponibilidade: servicoCompleto.tipo_disponibilidade || "unico",
        tipo_cobranca: servicoCompleto.tipo_cobranca || "valor_total",
        duracao_minutos: servicoCompleto.duracao_minutos || "",
        descricao: servicoCompleto.descricao || "",
        recorrencia: servicoCompleto.recorrencia ? {
          frequencia: servicoCompleto.recorrencia.frequencia || "semanal",
          diasDaSemana: Array.isArray(servicoCompleto.recorrencia.diasDaSemana) ? servicoCompleto.recorrencia.diasDaSemana : [],
          dataFim: formatarData(servicoCompleto.recorrencia.dataFim)
        } : {
          frequencia: "semanal",
          diasDaSemana: [],
          dataFim: ""
        },
        precificacao: {
          valorCliente: servicoCompleto.precificacao?.valorCliente 
            ? formatarMoeda(servicoCompleto.precificacao.valorCliente) 
            : "",
          valorColaborador: servicoCompleto.precificacao?.valorColaborador 
            ? formatarMoeda(servicoCompleto.precificacao.valorColaborador) 
            : "",
          taxaAdministrativa: servicoCompleto.precificacao?.taxaAdministrativa 
            ? formatarMoeda(servicoCompleto.precificacao.taxaAdministrativa) 
            : "",
          custosAdicionaisColaborador: servicoCompleto.precificacao?.custosAdicionaisColaborador || []
        },
        validade: {
          dataInicio: formatarData(servicoCompleto.validade?.dataInicio),
          dataFim: formatarData(servicoCompleto.validade?.dataFim)
        },
        local_execucao: servicoCompleto.local_execucao ? {
          tipo: normalizarTipoLocalExecucao(servicoCompleto.local_execucao.tipo),
          id: servicoCompleto.local_execucao.id || null,
          local: servicoCompleto.local_execucao.local || "",
          horario_inicio: servicoCompleto.local_execucao.horario_inicio || ""
        } : {
          tipo: "online",
          id: null,
          local: "",
          horario_inicio: ""
        },
        garantia_dias: servicoCompleto.garantia_dias || "",
        colaboradores: colaboradoresIds
      });
      
      setActiveTab(0);
      setOpenForm(true);
    } catch (error) {
      console.error("Erro ao abrir edição:", error);
      setError("Erro ao carregar dados do serviço para edição");
    } finally {
      setLoading(false);
    }
  };

  const handleAbrirView = async (servico) => {
    try {
      setLoading(true);
      
      // Tentar buscar o serviço completo do backend
      let servicoCompleto = await obterServico(servico.id);
      
      // Se não conseguir do backend, usar os dados da lista como fallback
      if (!servicoCompleto) {
        servicoCompleto = servico;
      }
      
      setServicoVisualizar(servicoCompleto);
      
      // Carregar colaboradores associados ao serviço
      if (servicoCompleto.colaboradores && Array.isArray(servicoCompleto.colaboradores) && servicoCompleto.colaboradores.length > 0) {
        // Se os colaboradores já vierem no objeto, usar diretamente
        setColaboradoresAssociados(servicoCompleto.colaboradores);
      } else {
        // Caso contrário, buscar separadamente
        if (servicoCompleto.id) {
          carregarColaboradoresAssociados(servicoCompleto.id);
        }
      }
      
      setOpenView(true);
    } catch (error) {
      console.error("Erro ao abrir visualização:", error);
      // Mesmo com erro, tentar abrir com os dados básicos
      setServicoVisualizar(servico);
      setOpenView(true);
      if (servico && servico.id) {
        carregarColaboradoresAssociados(servico.id);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async () => {
    // Validação completa do formulário antes de enviar
    if (!validarCamposObrigatorios()) {
      return; // A função já exibe o erro e retorna false
    }

    try {
      setLoading(true);

      const dadosFormatados = formatarDadosFormulario();

      // Remover campos null/undefined/vazios de objetos aninhados antes de enviar
      const limparObjeto = (obj) => {
        if (obj === null || obj === undefined) return null;
        if (typeof obj !== 'object' || Array.isArray(obj)) return obj;
        
        const limpo = {};
        for (const [key, value] of Object.entries(obj)) {
          if (value === null || value === undefined || value === '') {
            continue; // Não incluir campos vazios
          }
          if (typeof value === 'object' && !Array.isArray(value)) {
            const objLimpo = limparObjeto(value);
            if (objLimpo !== null && Object.keys(objLimpo).length > 0) {
              limpo[key] = objLimpo;
            }
          } else {
            limpo[key] = value;
          }
        }
        return Object.keys(limpo).length > 0 ? limpo : null;
      };

      const dadosParaEnviar = {
        ...dadosFormatados,
        descricao: dadosFormatados.descricao || null,
        validade: limparObjeto(dadosFormatados.validade),
        recorrencia: limparObjeto(dadosFormatados.recorrencia),
        local_execucao: limparObjeto(dadosFormatados.local_execucao)
      };

      // Log para debug (remover em produção)
      console.log('📤 Dados formatados para envio:', JSON.stringify(dadosParaEnviar, null, 2));

      await api.post('/servicos', dadosParaEnviar);

      setSuccess("Serviço criado com sucesso!");
      setOpenForm(false);
      carregarServicos();
    } catch (err) {
      console.error("Erro ao criar serviço:", err);
      console.error("Detalhes do erro:", err.response?.data);
      
      // Exibir detalhes específicos do erro de validação
      if (err.response?.data?.detalhes && Array.isArray(err.response.data.detalhes)) {
        const detalhesErro = err.response.data.detalhes.map(d => d.message || d).join('. ');
        setError(`Erro de validação: ${detalhesErro}`);
      } else {
        setError(err.response?.data?.message || "Erro ao criar serviço");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    // Validação completa do formulário antes de enviar
    if (!validarCamposObrigatorios()) {
      return; // A função já exibe o erro e retorna false
    }

    try {
      setLoading(true);

      const dadosFormatados = formatarDadosFormulario();

      // Validações finais
      if (!servicoSelecionado?.id) {
        setError("ID do serviço não encontrado");
        setLoading(false);
        return;
      }
      if (!codHashEmpresa) {
        setError("Código da empresa não encontrado");
        setLoading(false);
        return;
      }

      // ✅ CORREÇÃO: Montar o payload de forma explícita para garantir a estrutura correta.
      // A função `limparCamposNulos` foi removida pois pode omitir campos que o backend espera receber (mesmo que nulos).
      const dadosParaEnviar = {
        ...dadosFormatados,
        // Garante que o tipo de `local_execucao` seja enviado corretamente.
        // Se for 'online', envia o objeto { tipo: 'online' } em vez de null.
        local_execucao: dadosFormatados.local_execucao?.tipo === 'online' 
          ? { tipo: 'online' } 
          : dadosFormatados.local_execucao,
      };

      // Enviar todos os dados completos de uma vez
      await api.put(`/servicos/${servicoSelecionado.id}`, dadosParaEnviar);

      setSuccess("Serviço atualizado com sucesso!");
      setOpenForm(false);
      carregarServicos();
    } catch (err) {
      
      let mensagemErro = "Erro ao atualizar serviço";
      
      if (err.response?.status === 400) {
        mensagemErro = "Dados inválidos enviados para o servidor";
        if (err.response?.data?.message) {
          mensagemErro += `: ${err.response.data.message}`;
        }
        if (err.response?.data?.detalhes && Array.isArray(err.response.data.detalhes)) {
          const errosDetalhados = err.response.data.detalhes.map(e => {
            const campo = e.path?.join('.') || 'campo desconhecido';
            return `${campo}: ${e.message}`;
          }).join('; ');
          mensagemErro += ` - ${errosDetalhados}`;
        } else if (err.response?.data?.errors) {
          mensagemErro += ` - Erros: ${JSON.stringify(err.response.data.errors)}`;
        }
      } else if (err.response?.data?.message) {
        mensagemErro = err.response.data.message;
      }
      
      setError(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  const confirmarExclusao = (servico) => {
    setServicoParaExcluir(servico);
    setOpenDeleteConfirm(true);
  };

  const fecharConfirmacaoExclusao = () => {
    setOpenDeleteConfirm(false);
    setServicoParaExcluir(null);
  };

  const handleDelete = async () => {
    if (!servicoParaExcluir) return;

    try {
      await api.delete(`/servicos/${servicoParaExcluir.id}`);
      
      setSuccess("Serviço excluído com sucesso!");
      fecharConfirmacaoExclusao();
      carregarServicos();
    } catch (err) {
      console.error("Erro ao excluir serviço:", err);
      setError(err.response?.data?.message || "Erro ao excluir serviço");
    }
  };

  // Filtros aplicados
  const servicosFiltrados = servicos.filter(servico => {
    const matchNome = !filtros.nome || 
      (servico.nome && servico.nome.toLowerCase().includes(filtros.nome.toLowerCase()));
    const matchCategoria = !filtros.categoria || 
      (servico.categoria && String(servico.categoria) === String(filtros.categoria));
    const matchTipoDisponibilidade = !filtros.tipo_disponibilidade || 
      (servico.tipo_disponibilidade && servico.tipo_disponibilidade === filtros.tipo_disponibilidade);
    const matchTipoCobranca = !filtros.tipo_cobranca || 
      (servico.tipo_cobranca && servico.tipo_cobranca === filtros.tipo_cobranca);
    
    return matchNome && matchCategoria && matchTipoDisponibilidade && matchTipoCobranca;
  });

  // Ordenação
  const servicosOrdenados = servicosFiltrados.sort((a, b) => {
    const isAsc = order === "asc";
    
    if (orderBy === "nome") {
      const nomeA = (a.nome || '').toLowerCase();
      const nomeB = (b.nome || '').toLowerCase();
      return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
    }
    
    if (orderBy === "categoria") {
      const catA = obterNomeCategoria(a.categoria).toLocaleLowerCase('pt-BR');
      const catB = obterNomeCategoria(b.categoria).toLocaleLowerCase('pt-BR');
      return isAsc ? catA.localeCompare(catB) : catB.localeCompare(catA);
    }
    
    // Ordenação padrão por ID
    const valA = a[orderBy] || 0;
    const valB = b[orderBy] || 0;
    return isAsc ? valA - valB : valB - valA;
  });

  const servicosPaginados = servicosOrdenados.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    const totalRegistros = servicosOrdenados.length;
    const totalPaginas = totalRegistros > 0 ? Math.ceil(totalRegistros / rowsPerPage) - 1 : 0;
    const paginaMaxima = Math.max(totalPaginas, 0);

    if (page > paginaMaxima) {
      setPage(paginaMaxima);
    }
  }, [servicosOrdenados.length, rowsPerPage, page]);

  // Verificar acesso do usuário
  if (!verificarAcessoUsuario("servicos")) {
    return <AcessoRestrito />;
  }

  return (
    <AcessoRestrito modulo="servicos">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Snackbars para notificações */}
        <Snackbar 
          open={!!error} 
          autoHideDuration={CONSTANTS.NOTIFICATION_DURATION} 
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>

        <Snackbar 
          open={!!success} 
          autoHideDuration={CONSTANTS.NOTIFICATION_DURATION} 
          onClose={() => setSuccess(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
            {success}
          </Alert>
        </Snackbar>

        {/* Box interno com margens de 1,5% */}
        <Box sx={{
          margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Header responsivo */}
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            pb: 2,
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Typography 
              variant="h5" 
              mb={1} 
              sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              {React.cloneElement(getModuleIcon(), {
                sx: {
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  color: theme.palette.warning.main
                }
              })}
              Serviços
            </Typography>
            <Button 
              variant="contained" 
              onClick={handleAbrirCreate}
              sx={{ 
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: 'auto', sm: '200px' },
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? theme.palette.background.paper
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? theme.palette.text.primary
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? theme.palette.action.hover
                    : theme.palette.primary.dark,
                }
              }}
            >
              <AddIcon /> Novo Serviço
            </Button>
          </Box>

          {/* Container da Tabela */}
          <TableContainer 
            component={Paper} 
            sx={{ 
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'auto',
              height: {
                xs: 'calc(90vh - 140px)',  // Mobile: mais espaço para header
                sm: 'calc(90vh - 120px)',  // Tablet: espaço padrão
                md: 'calc(90vh - 120px)',  // Desktop: espaço padrão
                lg: 'calc(90vh - 120px)'   // Large: espaço padrão
              },
              maxHeight: {
                xs: 'calc(90vh - 140px)',
                sm: 'calc(90vh - 120px)',
                md: 'calc(90vh - 120px)',
                lg: 'calc(90vh - 120px)'
              },
              width: '100%', // ✅ 100% da largura da página
              minWidth: { xs: '100%', sm: CONSTANTS.DIMENSIONS.MOBILE_BREAKPOINT }, // ✅ 100% do mínimo também
              maxWidth: '100%', // ✅ Limita a 100% máximo
              boxShadow: (theme) => theme.palette.mode === 'dark' 
                ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
                : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 2,
              border: 'none'
            }}
          >
        {loading && (
          <Box
                              sx={{
            position: 'absolute',
              top: 0,
            left: 0,
            right: 0,
              bottom: 0,
            display: 'flex',
            alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
                zIndex: 1
              }}
            >
            <CircularProgress />
          </Box>
        )}
        
            <Table sx={{ 
              minWidth: { xs: parseInt(CONSTANTS.DIMENSIONS.DESKTOP_BREAKPOINT), sm: parseInt(CONSTANTS.DIMENSIONS.TABLE_BREAKPOINT) }, 
              tableLayout: 'fixed',
              width: '100%'
            }}>
            <TableHead sx={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              backgroundColor: (theme) => theme.palette.background.paper,
              '& .MuiTableCell-root': {
                backgroundColor: (theme) => theme.palette.background.paper,
                borderBottom: 2,
                borderBottomColor: 'divider',
                fontWeight: 'normal'
              }
            }}>
              <TableRow>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '25%' },
                  minWidth: { xs: '150px', sm: '120px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "nome"}
                    direction={orderBy === "nome" ? order : "asc"}
                    onClick={() => handleRequestSort("nome")}
                  >
                    Nome do Serviço
                  </TableSortLabel>
                  <TextField
                    name="nome"
                    size="small"
                    fullWidth
                    value={filtros.nome}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por nome"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
              </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '20%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "categoria"}
                    direction={orderBy === "categoria" ? order : "asc"}
                    onClick={() => handleRequestSort("categoria")}
                  >
                    Categoria
                  </TableSortLabel>
                  <FormControl fullWidth size="small">
                    <Select
                      name="categoria"
                      value={filtros.categoria}
                      onChange={handleFiltroChange}
                      displayEmpty
                      sx={{ 
                        '& .MuiSelect-select': {
                          fontSize: { xs: '0.75rem', sm: '0.875rem' }
                        }
                      }}
                    >
                      <MenuItem value="">Todas as categorias</MenuItem>
                      {categorias.map((categoria) => (
                        <MenuItem key={categoria.categoriaId} value={categoria.categoriaId}>
                          {categoria.st_nomeCategoria || `Categoria ${categoria.categoriaId}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '15%' },
                  minWidth: { xs: '80px', sm: '70px' }
                }}>
                  Tipo
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '15%' },
                  minWidth: { xs: '80px', sm: '70px' }
                }}>
                  Duração
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '15%' },
                  minWidth: { xs: '80px', sm: '70px' }
                }}>
                  Valor
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '10%', sm: '10%' },
                  minWidth: { xs: '100px', sm: '80px' }
                }}>
                  Ações
                </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {servicosPaginados.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="body1" color="text.secondary">
                    {servicos.length === 0 
                      ? "Nenhum serviço encontrado. Clique em 'Novo Serviço' para começar."
                      : "Nenhum serviço corresponde aos filtros aplicados."
                    }
              </Typography>
                </TableCell>
              </TableRow>
            ) : (
              servicosPaginados.map((servico, index) => (
                <TableRow 
                  key={servico.id} 
                  hover
                  sx={{
                    backgroundColor: (theme) => 
                      index % 2 === 0 
                        ? (theme.palette.mode === 'dark' 
                            ? 'rgba(255, 255, 255, 0.02)' 
                            : 'rgba(0, 0, 0, 0.02)')
                        : (theme.palette.mode === 'dark' 
                            ? 'rgba(255, 255, 255, 0.04)' 
                            : 'rgba(0, 0, 0, 0.04)'),
                    '&:hover': {
                      backgroundColor: (theme) => 
                        theme.palette.mode === 'dark' 
                          ? 'rgba(255, 255, 255, 0.08)' 
                          : 'rgba(0, 0, 0, 0.08)',
                      transition: 'background-color 0.2s ease'
                    }
                  }}
                >
                  <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <Typography variant="body2">
                      {typeof servico.nome === 'string' ? servico.nome : 
                       (typeof servico.nome === 'object' ? servico.nome?.nome || 'N/A' : 'N/A')}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <Typography variant="body2" color="text.secondary">
                      {obterNomeCategoria(servico.categoria)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={servico.tipo_disponibilidade === 'unico' ? 'Único' : 'Recorrente'} 
                      size="small" 
                      color={servico.tipo_disponibilidade === 'unico' ? 'primary' : 'secondary'}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {servico.duracao_minutos ? `${servico.duracao_minutos} min` : '0 min'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {servico.precificacao?.valorCliente && typeof servico.precificacao.valorCliente === 'number' 
                        ? formatarMoeda(servico.precificacao.valorCliente) 
                        : '-'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ 
                    textAlign: 'right', // ✅ Alinha o conteúdo à direita
                    paddingRight: 3 // ✅ Adiciona padding à direita
                  }}>
                    <Box sx={{ 
                      display: 'flex', 
                      gap: 1,
                      justifyContent: 'flex-end' // ✅ Alinha os botões à direita
                    }}>
                      <Tooltip title="Visualizar">
                        <IconButton size="small" onClick={() => handleAbrirView(servico)}>
                          <VisibilityIcon fontSize="small" className="material-icon-visibility" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Editar">
                        <IconButton size="small" onClick={() => handleAbrirEdit(servico)}>
                          <EditIcon fontSize="small" className="material-icon-edit" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir">
                        <IconButton size="small" onClick={() => confirmarExclusao(servico)}>
                          <DeleteIcon fontSize="small" className="material-icon-delete" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
          </TableContainer>
          
          {/* Paginação fora do TableContainer (igual ao Colaboradores) */}
          <TablePagination
            component="div"
            count={servicosOrdenados.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count }) => {
              const total = count !== -1 ? count : servicosOrdenados.length;
              return `${from}-${to} de ${total}`;
            }}
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
              borderTop: 'none',
              width: '100%', // ✅ 100% da largura da página
              marginTop: 0
            }}
          />
        </Box> {/* Fechamento do Box interno com margens */}

        {/* Dialog de confirmação de exclusão */}
        <Dialog
          open={openDeleteConfirm}
          onClose={fecharConfirmacaoExclusao}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: (theme) => theme.palette.background.paper
            }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            Confirmar Exclusão
          </DialogTitle>
          <DialogContent sx={{ padding: 3 }}>
            <Typography>
              Tem certeza que deseja excluir o serviço <strong>{servicoParaExcluir?.nome}</strong>?
              Esta ação não pode ser desfeita.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderTop: 1,
            borderColor: 'divider',
            padding: 2,
            gap: 1
          }}>
            <Button 
              onClick={fecharConfirmacaoExclusao}
              variant="outlined"
              sx={{ 
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              CANCELAR
            </Button>
            <Button 
              onClick={handleDelete}
              variant="contained"
              color="error"
              sx={{ 
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              EXCLUIR
            </Button>
          </DialogActions>
      </Dialog>

        {/* Dialog de Formulário (Criação/Edição) */}
        <Dialog
          open={openForm}
          onClose={(_event, reason) => {
            if (reason !== 'backdropClick') {
              setOpenForm(false);
              resetForm();
              setServicoSelecionado(null);
            }
          }}
          maxWidth={false}
          fullWidth={false}
          disableEscapeKeyDown
          disablePortal
          hideBackdrop={false}
          sx={{
            '& .MuiDialog-backdrop': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }
          }}
          PaperProps={dialogCommonStyles.paperProps}
        >
          <DialogTitle sx={dialogCommonStyles.title}>
            {servicoSelecionado ? "Editar Serviço" : "Novo Serviço"}
            <IconButton
              onClick={() => {
                setOpenForm(false);
                resetForm();
                setServicoSelecionado(null);
              }}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={dialogCommonStyles.content}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
              <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} aria-label="formulário de serviço">
                <Tab label="Dados Básicos" />
                <Tab label="Precificação" />
                <Tab label="Disponibilidade" />
                <Tab label="Local" />
                <Tab label="Colaboradores" />
                <Tab label="Outros" />
              </Tabs>
            </Box>

            {/* Aba 0: Dados Básicos */}
            {activeTab === 0 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <TextField 
                  fullWidth 
                  label="Nome do Serviço *"
                  value={formData.nome}
                  onChange={(e) => {
                    setFormData({ ...formData, nome: e.target.value });
                    validarCampo('nome', e.target.value);
                  }}
                  required
                  error={!formData.nome && camposPreenchidos.has('nome') === false && formData.nome === ''}
                  helperText={!formData.nome && camposPreenchidos.has('nome') === false && formData.nome === '' ? 'Campo obrigatório' : ''}
                />
                <FormControl fullWidth required error={!formData.categoria}>
                  <InputLabel>Categoria *</InputLabel>
                  <Select
                    value={formData.categoria}
                    onChange={(e) => {
                      setFormData({ ...formData, categoria: e.target.value });
                      validarCampo('categoria', e.target.value);
                    }}
                    label="Categoria *"
                  >
                    <MenuItem value="">Selecione uma categoria</MenuItem>
                    {categorias.map((categoria) => (
                      <MenuItem key={categoria.categoriaId} value={categoria.categoriaId}>
                        {categoria.st_nomeCategoria || `Categoria ${categoria.categoriaId}`}
                      </MenuItem>
                    ))}
                  </Select>
                  {!formData.categoria && <FormHelperText>Campo obrigatório</FormHelperText>}
                </FormControl>
                <TextField 
                  fullWidth 
                  label="Duração (minutos) *"
                  type="number"
                  value={formData.duracao_minutos}
                  onChange={(e) => {
                    setFormData({ ...formData, duracao_minutos: e.target.value });
                    validarCampo('duracao_minutos', e.target.value);
                  }}
                  required
                  error={!formData.duracao_minutos || formData.duracao_minutos <= 0}
                  helperText={(!formData.duracao_minutos || formData.duracao_minutos <= 0) ? 'Campo obrigatório' : ''}
                />
                <TextField 
                  fullWidth 
                  label="Descrição"
                  value={formData.descricao}
                  onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
                  multiline
                  rows={3}
                />
              </Box>
            )}

            {/* Aba 1: Precificação */}
            {activeTab === 1 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <TextField 
                  fullWidth 
                  label="Valor para Cliente" 
                  value={formData.precificacao?.valorCliente || ''}
                  onChange={(e) => {
                    const valorFormatado = formatarMoedaInput(e.target.value);
                    setFormData({ 
                      ...formData, 
                      precificacao: { 
                        ...formData.precificacao, 
                        valorCliente: valorFormatado 
                      } 
                    });
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
                <TextField 
                  fullWidth 
                  label="Valor para Colaborador" 
                  value={formData.precificacao?.valorColaborador || ''}
                  onChange={(e) => {
                    const valorFormatado = formatarMoedaInput(e.target.value);
                    setFormData({ 
                      ...formData, 
                      precificacao: { 
                        ...formData.precificacao, 
                        valorColaborador: valorFormatado 
                      } 
                    });
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
                <TextField 
                  fullWidth 
                  label="Taxa Administrativa" 
                  value={formData.precificacao?.taxaAdministrativa || ''}
                  onChange={(e) => {
                    const valorFormatado = formatarMoedaInput(e.target.value);
                    setFormData({ 
                      ...formData, 
                      precificacao: { 
                        ...formData.precificacao, 
                        taxaAdministrativa: valorFormatado 
                      } 
                    });
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                  }}
                />
              </Box>
            )}

            {/* Aba 2: Disponibilidade */}
            {activeTab === 2 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <FormControl fullWidth required>
                  <InputLabel>Tipo de Disponibilidade *</InputLabel>
                  <Select
                    value={formData.tipo_disponibilidade}
                    onChange={(e) => setFormData({ ...formData, tipo_disponibilidade: e.target.value })}
                    label="Tipo de Disponibilidade *"
                  >
                    <MenuItem value="unico">Único</MenuItem>
                    <MenuItem value="recorrente">Recorrente</MenuItem>
                  </Select>
                </FormControl>
                
                {formData.tipo_disponibilidade === 'recorrente' && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <FormControl fullWidth>
                      <InputLabel>Frequência</InputLabel>
                      <Select
                        value={formData.recorrencia?.frequencia || 'semanal'}
                        onChange={(e) => setFormData({ 
                          ...formData, 
                          recorrencia: { 
                            ...formData.recorrencia, 
                            frequencia: e.target.value 
                          } 
                        })}
                        label="Frequência"
                      >
                        <MenuItem value="diaria">Diária</MenuItem>
                        <MenuItem value="semanal">Semanal</MenuItem>
                        <MenuItem value="mensal">Mensal</MenuItem>
                      </Select>
                    </FormControl>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      Dias da Semana
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {diasDaSemana.map((dia) => (
                        <FormControlLabel
                          key={dia.value}
                          control={
                            <Checkbox
                              checked={Array.isArray(formData.recorrencia?.diasDaSemana) ? 
                                        formData.recorrencia.diasDaSemana.includes(dia.value) : false}
                              onChange={(e) => {
                                const diasAtuais = Array.isArray(formData.recorrencia?.diasDaSemana) 
                                  ? formData.recorrencia.diasDaSemana 
                                  : [];
                                const novosDias = e.target.checked
                                  ? [...diasAtuais, dia.value]
                                  : diasAtuais.filter(d => d !== dia.value);
                                setFormData({ 
                                  ...formData, 
                                  recorrencia: { 
                                    ...formData.recorrencia, 
                                    diasDaSemana: novosDias 
                                  } 
                                });
                              }}
                            />
                          }
                          label={dia.label}
                        />
                      ))}
                    </Box>
                    <TextField
                      fullWidth
                      label="Data de Fim"
                      value={formatarData(formData.recorrencia?.dataFim || '')}
                      onChange={(e) => {
                        const valorFormatado = handleDataChange('recorrencia.dataFim', e.target.value);
                        setFormData({ 
                          ...formData, 
                          recorrencia: { 
                            ...formData.recorrencia, 
                            dataFim: valorFormatado 
                          } 
                        });
                      }}
                      placeholder="DD/MM/AAAA"
                      inputProps={{
                        maxLength: 10
                      }}
                      helperText="Formato: DD/MM/AAAA"
                    />
                  </Box>
                )}
              </Box>
            )}

            {/* Aba 3: Local */}
            {activeTab === 3 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <FormControl fullWidth>
                  <InputLabel>Tipo de Local</InputLabel>
                  <Select
                    value={formData.local_execucao?.tipo || 'online'}
                    onChange={(e) => setFormData({ 
                      ...formData, 
                      local_execucao: { 
                        ...formData.local_execucao, 
                        tipo: e.target.value 
                      } 
                    })}
                    label="Tipo de Local"
                  >
                    <MenuItem value="online">Online</MenuItem>
                    <MenuItem value="presencial">Presencial</MenuItem>
                    <MenuItem value="hibrido">Híbrido</MenuItem>
                  </Select>
                </FormControl>
                {formData.local_execucao?.tipo !== 'online' && (
                  <>
                    <FormControl fullWidth>
                      <InputLabel>Local</InputLabel>
                      <Select
                        value={formData.local_execucao?.id || ''}
                        onChange={(e) => {
                          const localSelecionado = locais.find(l => l.id === e.target.value);
                          setFormData({ 
                            ...formData, 
                            local_execucao: { 
                              ...formData.local_execucao, 
                              id: e.target.value,
                              local: localSelecionado?.nome || ''
                            } 
                          });
                        }}
                        label="Local"
                        disabled={loadingLocais}
                      >
                        <MenuItem value="">Selecione um local</MenuItem>
                        {locais.map((local) => (
                          <MenuItem key={local.id} value={local.id}>
                            {local.nome || `Local ${local.id}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      fullWidth
                      label="Horário de Início"
                      type="time"
                      value={formData.local_execucao?.horario_inicio || ''}
                      onChange={(e) => setFormData({ 
                        ...formData, 
                        local_execucao: { 
                          ...formData.local_execucao, 
                          horario_inicio: e.target.value 
                        } 
                      })}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </>
                )}
              </Box>
            )}

            {/* Aba 4: Colaboradores */}
            {activeTab === 4 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <FormControl fullWidth>
                  <InputLabel>Especialistas</InputLabel>
                  <Select
                    multiple
                    value={formData.colaboradores || []}
                    onChange={(e) => setFormData({ ...formData, colaboradores: e.target.value })}
                    label="Especialistas"
                    renderValue={(selected) => {
                      const idsSelecionados = new Set(selected.map(normalizarId));
                      const selecionados = colaboradores.filter(col => idsSelecionados.has(normalizarId(col.id)));
                      return selecionados.map(col => col.nome_completo || col.nome).join(', ');
                    }}
                  >
                    {colaboradores.map((colaborador) => (
                      <MenuItem key={colaborador.id} value={colaborador.id}>
                        {colaborador.nome_completo || colaborador.nome || `Colaborador ${colaborador.id}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {formData.colaboradores && formData.colaboradores.length > 0 && (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                    {formData.colaboradores.map((colId) => {
                      const colaborador = colaboradores.find(col => normalizarId(col.id) === normalizarId(colId));
                      return colaborador ? (
                        <Chip
                          key={colId}
                          label={colaborador.nome_completo || colaborador.nome}
                          onDelete={() => {
                            setFormData({ 
                              ...formData, 
                              colaboradores: formData.colaboradores.filter(id => normalizarId(id) !== normalizarId(colId))
                            });
                          }}
                          size="small"
                        />
                      ) : null;
                    })}
                  </Box>
                )}
              </Box>
            )}

            {/* Aba 5: Outros */}
            {activeTab === 5 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <TextField 
                  fullWidth 
                  label="Garantia (dias)" 
                  type="number"
                  value={formData.garantia_dias}
                  onChange={(e) => setFormData({ ...formData, garantia_dias: e.target.value })}
                />
                <TextField 
                  fullWidth 
                  label="Data de Início" 
                  value={formatarData(formData.validade?.dataInicio || '')}
                  onChange={(e) => {
                    const valorFormatado = handleDataChange('validade.dataInicio', e.target.value);
                    setFormData({ 
                      ...formData, 
                      validade: { 
                        ...formData.validade, 
                        dataInicio: valorFormatado 
                      } 
                    });
                  }}
                  placeholder="DD/MM/AAAA"
                  inputProps={{
                    maxLength: 10
                  }}
                  helperText="Formato: DD/MM/AAAA"
                />
                <TextField 
                  fullWidth 
                  label="Data de Fim" 
                  value={formatarData(formData.validade?.dataFim || '')}
                  onChange={(e) => {
                    const valorFormatado = handleDataChange('validade.dataFim', e.target.value);
                    setFormData({ 
                      ...formData, 
                      validade: { 
                        ...formData.validade, 
                        dataFim: valorFormatado 
                      } 
                    });
                  }}
                  placeholder="DD/MM/AAAA"
                  inputProps={{
                    maxLength: 10
                  }}
                  helperText="Formato: DD/MM/AAAA"
                />
                <FormControl fullWidth>
                  <InputLabel>Tipo de Cobrança</InputLabel>
                  <Select
                    value={formData.tipo_cobranca}
                    onChange={(e) => {
                      setFormData({ ...formData, tipo_cobranca: e.target.value });
                      validarCampo('tipo_cobranca', e.target.value);
                    }}
                    label="Tipo de Cobrança"
                  >
                    <MenuItem value="valor_total">Valor Total</MenuItem>
                    <MenuItem value="por_hora">Por Hora</MenuItem>
                    <MenuItem value="por_dia">Por Dia</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={dialogCommonStyles.actions}>
            <Typography variant="body2" color="text.secondary">
              {dataHoraAtual.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button 
                variant="outlined"
                onClick={() => {
                  setOpenForm(false);
                  resetForm();
                  setServicoSelecionado(null);
                }}
                sx={{
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  fontWeight: 500
                }}
              >
                Cancelar
              </Button>
              <Button 
                variant="contained" 
                onClick={servicoSelecionado ? handleUpdate : handleCreate}
                disabled={loading}
                sx={{ 
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  fontWeight: 500
                }}
              >
                {loading ? <CircularProgress size={20} /> : (servicoSelecionado ? "Atualizar" : "Criar")}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>

        {/* Dialog de Visualização */}
        <Dialog
          open={openView}
          onClose={(_event, reason) => {
            if (reason !== 'backdropClick') {
              setOpenView(false);
            }
          }}
          maxWidth={false}
          fullWidth={false}
          disableEscapeKeyDown
          disablePortal
          hideBackdrop={false}
          sx={{
            '& .MuiDialog-backdrop': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }
          }}
          PaperProps={dialogCommonStyles.paperProps}
        >
          <DialogTitle sx={dialogCommonStyles.title}>
            Detalhes do Serviço
            <IconButton
              onClick={() => setOpenView(false)}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        <DialogContent sx={dialogCommonStyles.content}>
          {servicoVisualizar && (
            <>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} aria-label="visualização de serviço">
                  <Tab label="Dados Básicos" />
                  <Tab label="Precificação" />
                  <Tab label="Disponibilidade" />
                  <Tab label="Local" />
                  <Tab label="Colaboradores" />
                  <Tab label="Outros" />
                </Tabs>
              </Box>

              {/* Campos do formulário */}
              {activeTab === 0 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  <TextField 
                    fullWidth 
                    label="Nome do Serviço"
                    value={typeof servicoVisualizar.nome === 'string' ? servicoVisualizar.nome : 
                           (typeof servicoVisualizar.nome === 'object' ? servicoVisualizar.nome?.nome || 'N/A' : 'N/A')}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Categoria"
                    value={obterNomeCategoria(servicoVisualizar.categoria)}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField 
                    fullWidth 
                    label="Duração (minutos)"
                    value={typeof servicoVisualizar.duracao_minutos === 'number' ? servicoVisualizar.duracao_minutos : 
                           (typeof servicoVisualizar.duracao_minutos === 'object' ? servicoVisualizar.duracao_minutos?.duracao || 0 : 0)}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField 
                    fullWidth 
                    label="Descrição"
                    value={servicoVisualizar.descricao || ''}
                    disabled
                    multiline
                    rows={3}
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                </Box>
              )}

              {activeTab === 1 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  <TextField 
                    fullWidth 
                    label="Valor para Cliente" 
                    value={servicoVisualizar.precificacao?.valorCliente && typeof servicoVisualizar.precificacao.valorCliente === 'number' 
                           ? formatarMoeda(servicoVisualizar.precificacao.valorCliente) 
                           : '-'}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField 
                    fullWidth 
                    label="Valor para Colaborador" 
                    value={servicoVisualizar.precificacao?.valorColaborador && typeof servicoVisualizar.precificacao.valorColaborador === 'number' 
                           ? formatarMoeda(servicoVisualizar.precificacao.valorColaborador) 
                           : '-'}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField 
                    fullWidth 
                    label="Taxa Administrativa" 
                    value={servicoVisualizar.precificacao?.taxaAdministrativa && typeof servicoVisualizar.precificacao.taxaAdministrativa === 'number' 
                           ? formatarMoeda(servicoVisualizar.precificacao.taxaAdministrativa) 
                           : '-'}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                </Box>
              )}

              {activeTab === 2 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  <TextField
                    fullWidth
                    label="Tipo de Disponibilidade"
                    value={servicoVisualizar.tipo_disponibilidade || 'unico'}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  
                  {servicoVisualizar.tipo_disponibilidade === 'recorrente' && (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Dias da Semana
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {diasDaSemana.map((dia) => (
                          <FormControlLabel
                            key={dia.value}
                            control={
                              <Checkbox
                                checked={Array.isArray(servicoVisualizar.recorrencia?.diasDaSemana) ? 
                                          servicoVisualizar.recorrencia.diasDaSemana.includes(dia.value) : false}
                                disabled
                              />
                            }
                            label={dia.label}
                            sx={{ 
                              '& .MuiFormControlLabel-label': {
                                color: 'text.secondary'
                              }
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>
              )}

              {activeTab === 3 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  <TextField
                    fullWidth
                    label="Tipo de Local"
                    value={servicoVisualizar.local_execucao?.tipo || ''}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  {servicoVisualizar.local_execucao?.tipo !== 'online' && (
                    <TextField
                      fullWidth
                      label="Local"
                      value={servicoVisualizar.local_execucao?.local || ''}
                      disabled
                      sx={{ 
                        '& .MuiInputBase-input': {
                          color: 'text.secondary'
                        }
                      }}
                    />
                  )}
                </Box>
              )}

              {activeTab === 4 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  {loadingColaboradoresAssociados ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
                      <CircularProgress size={20} />
                      <Typography variant="body2" color="text.secondary">
                        Carregando colaboradores...
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Colaboradores Associados ao Serviço
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {colaboradoresAssociados && colaboradoresAssociados.length > 0 ? 
                          colaboradoresAssociados.map((colaborador) => (
                            <Chip
                              key={colaborador.id}
                              label={`${colaborador.nome_completo}${colaborador.cargo ? ` - ${colaborador.cargo}` : ''}`}
                              size="small"
                              sx={{
                                '& .MuiChip-label': {
                                  color: 'text.secondary'
                                }
                              }}
                            />
                          )) : 
                          <Typography variant="body2" color="text.secondary">
                            Nenhum colaborador associado a este serviço
                          </Typography>
                        }
                      </Box>
                      {colaboradoresAssociados && colaboradoresAssociados.length > 0 && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="body2" color="text.secondary" gutterBottom>
                            Detalhes dos Colaboradores:
                          </Typography>
                          {colaboradoresAssociados.map((colaborador) => (
                            <Box key={colaborador.id} sx={{ 
                              p: 2, 
                              mb: 1, 
                              border: 1, 
                              borderColor: 'divider', 
                              borderRadius: 1,
                              backgroundColor: 'background.paper'
                            }}>
                              <Typography variant="body2" fontWeight="medium">
                                {colaborador.nome_completo}
                              </Typography>
                              {colaborador.cargo && (
                                <Typography variant="body2" color="text.secondary">
                                  Cargo: {colaborador.cargo}
                                </Typography>
                              )}
                              {colaborador.email && (
                                <Typography variant="body2" color="text.secondary">
                                  Email: {colaborador.email}
                                </Typography>
                              )}
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              )}

              {activeTab === 5 && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  <TextField 
                    fullWidth 
                    label="Garantia (dias)" 
                    value={servicoVisualizar.garantia_dias || ''}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField 
                    fullWidth 
                    label="Data de Início" 
                    value={converterDataParaBR(servicoVisualizar.validade?.dataInicio)}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField 
                    fullWidth 
                    label="Data de Fim" 
                    value={converterDataParaBR(servicoVisualizar.validade?.dataFim)}
                    disabled
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                  <TextField 
                    fullWidth 
                    label="Observações" 
                    value={servicoVisualizar.observacoes || ''}
                    disabled
                    multiline
                    rows={3}
                    sx={{ 
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }}
                  />
                </Box>
              )}
            </>
          )}
        </DialogContent>
          <DialogActions sx={dialogCommonStyles.actions}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained"
              onClick={() => {
                setOpenView(false);
                if (servicoVisualizar) {
                  handleAbrirEdit(servicoVisualizar);
                }
              }}
              sx={{
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              Editar
            </Button>
            <Button 
              variant="outlined"
              onClick={() => setOpenView(false)}
              sx={{
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              Fechar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
        </Box> {/* Fechamento do Box interno com margens */}
    </AcessoRestrito>
  );
}
